import { AfterViewInit, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from 'app/services/auth.service';
import { PersonPointService } from 'app/services/models/person-point.service';
import { PersonService } from 'app/services/models/person.service';
import Stepper from 'bs-stepper';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { link } from 'fs';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-update-worker',
  templateUrl: './update-worker.component.html',
  styleUrls: ['./update-worker.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UpdateWorkerComponent implements OnInit, AfterViewInit {
  public contentHeader: object;
  personForm: FormGroup;
  stepIndex: number = 0;

  person: any = {};
  personId: number;
  companies: any;
  isUpdate: any = true;

  birthDate: Date = null
  startDate: Date = null;
  leaveDate: Date = null;

  date = new Date();

  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
  };

  public dateTimeEndOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
  };

  public dateTimeLeaveJobOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,

  };

  private verticalWizardStepper: Stepper;

  constructor(
    private activatedRouter: ActivatedRoute,
    private personService: PersonService,
    private fb: FormBuilder,
    private toastrService: ToastrService,
    private personPointService: PersonPointService,
    public authService: AuthService
  ) {


  }

  horizontalWizardStepper!: Stepper; // Stepper nesnesi burada tanımlandı

  horizontalWizardStepperNext(form: FormGroup) {
    if (form && form.valid) {
      if (this.stepIndex < 3) {
        this.stepIndex++;
        if (this.horizontalWizardStepper) { // Stepper nesnesinin başlatıldığını kontrol et
          this.horizontalWizardStepper.next(); // Eğer başlatıldıysa next() fonksiyonunu çağır
        } else {
          console.error("Stepper başlatılmadı!");
        }
      }
    }
  }

  updateBtStepper(index){
    if (this.horizontalWizardStepper) { // Stepper nesnesinin başlatıldığını kontrol et
      this.stepIndex = index;  // Seçilen adımı stepIndex'e atıyoruz
      this.horizontalWizardStepper.to(index);  // İlgili adım numarasına git
    } else {
      console.error("Stepper başlatılmadı!");
    }
  }

  // Formu geri almak için kullanılan previous buton fonksiyonu
  horizontalWizardStepperPrevious() {
    if (this.stepIndex > 0) {
      this.stepIndex--;
      this.horizontalWizardStepper.previous();
    }
  }


  ngAfterViewInit() {
    if (!this.isUpdate) {
      setTimeout(() => {
        const stepperElement = document.querySelector('.bs-stepper');
        if (stepperElement) {
          this.horizontalWizardStepper = new Stepper(stepperElement, {
            linear: false,
            animation: true
          }); // Stepper'ı burada başlatıyoruz
        } else {
          console.error('Stepper elemanı bulunamadı!');
        }
      }, 0); // 0ms gecikme ile başlatma
    }
  }

  stepperInitialized = false;

  ngAfterViewChecked() {
    if (!this.isUpdate && !this.stepperInitialized) {
      const stepperElement = document.querySelector('.bs-stepper');
      if (stepperElement) {
        this.horizontalWizardStepper = new Stepper(stepperElement, {
          linear: false,
          animation: true
        });
        this.stepperInitialized = true;
      }
    }
  }

  async ngOnInit() {

    this.personForm = this.fb.group({
      name: [null, Validators.required],
      lastName: [null, Validators.required],
      mission: [null, Validators.required],
      phoneNumber: [null],
      mail: [null],
      address: [null],
      birthDay: [null],
      startDate: [null],
      workingStatus: [null],
      department: [null],
      emergencyContact: [null],
      tc: [null, [Validators.required, Validators.maxLength(11)]],
      wage: [null, Validators.min(0)],
      leaveJob: [null],
      registrationNumber: [null]
    });

    this.contentHeader = {
      headerTitle: 'Personel',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Personel Listesi',
            link: '/admin/person',
            isLink: true,
          },
          {
            name: 'Personel Güncelle',
            isLink: false,
          },
        ]
      }
    }
    this.personService.event$.subscribe(async result => {
      this.activatedRouter.params.subscribe(async params => {
        console.log(params);
        this.personId = params['id'];
        await this.getByIdWorker(params['id'])
      });
    })
    this.activatedRouter.params.subscribe(async params => {
      console.log(params);
      this.personId = params['id'];
      await this.getByIdWorker(params['id'])
    });

  }

  async getByIdWorker(id) {
    const data = await this.personService.getByIdWorker(id);
    console.log(data);
    this.person = data;
    if (this.person != null) {
      this.personForm.patchValue({
        name: this.person.name,
        lastName: this.person.lastName,
        mission: this.person.mission,
        phoneNumber: this.person.phoneNumber,
        mail: this.person.mail,
        address: this.person.address,
        birthDay: this.person.personalAdditionalInfarmation?.birthDay,
        startDate: this.person.personalAdditionalInfarmation?.startDate,
        workingStatus: this.person.personalAdditionalInfarmation?.workingStatus,
        department: this.person.personalAdditionalInfarmation?.department,
        emergencyContact: this.person.personalAdditionalInfarmation?.emergencyContact,
        tc: this.person.personalAdditionalInfarmation?.tc,
        wage: this.person.personalAdditionalInfarmation?.wage,
        leaveJob: this.person.personalAdditionalInfarmation?.leaveJob,
        registrationNumber: this.person.personalAdditionalInfarmation.registrationNumber
      });

      this.birthDate = new Date(this.personForm.value.birthDay);
      this.startDate = new Date(this.personForm.value.startDate);
      this.leaveDate = new Date(this.personForm.value.leaveJob);
    }
    this.updateWorkingDays(this.person.personalAdditionalInfarmation.workingDays ?? []);

    await this.calculatePersonPoints(id);
  }

  updateChange() {
    this.isUpdate = !this.isUpdate;
    this.stepperInitialized = false; // Yeniden başlatmak için
    this.stepIndex = 0;

  }

  calculate: any;

  async calculatePersonPoints(id) {
    const response = await this.personPointService.calculatePersonPoints(id);
    console.log(response);
    this.calculate = response;
  }

  async onSumbit() {
    if (this.personForm.valid) {
      console.log(this.personForm.value);

      const selectedDays = this.days
        .filter((day) => day.selected)
        .map((day) => ({
          Day: day.name,
          start: `${day.startTime.hour.toString().padStart(2, '0')}:${day.startTime.minute.toString().padStart(2, '0')}`,
          end: `${day.endTime.hour.toString().padStart(2, '0')}:${day.endTime.minute.toString().padStart(2, '0')}`,
        }));
      console.log(selectedDays);

      const formData = this.personForm.value;

      // `updateWorker` metodu için uygun veri formatını hazırlıyoruz
      const workerData = {
        id: this.person.id, // Eğer formda id yoksa varsayılan olarak 0 kullanılır
        name: formData.name,
        lastName: formData.lastName,
        mission: formData.mission,
        phoneNumber: formData.phoneNumber,
        mail: formData.mail,
        address: formData.address,
        companyId: 1, // Eğer formda companyId yoksa varsayılan olarak 0 kullanılır
        updatePersonalAdditionalInfarmation: {
          id: this.person.personalAdditionalInfarmation?.id ?? 0, // Varsayılan id değeri
          tc: formData.tc,
          birthDay: new Date(formData.birthDay[0]), // Tarih array içinden çekilir
          startDate: new Date(formData.startDate[0]), // Tarih array içinden çekilir
          department: formData.department,
          workingStatus: formData.workingStatus,
          wage: formData.wage,
          emergencyContact: formData.emergencyContact,
          personId: this.person.id, // Varsayılan personId değeri,
          leaveJob: formData.leaveJob != null ? new Date(formData.leaveJob[0]) : null,
          workingDays: selectedDays,
          registrationNumber: formData.registrationNumber
        },
      };
      console.log(workerData);
      const response = await this.personService.updateWorker(workerData);
      console.log(response);
      if (response.status == true) {
        this.updateChange();
        this.personService.sendEvent(true);
        this.toastrService.success(response.message);
        this.stepIndex = 0;
      } else {
        this.toastrService.error(response.message);
      }
    }
  }

  getWorkingHoursSummary(): string {
    // Türkçe gün isimlerinin haritalaması
    const dayTranslations = {
      'Monday': 'Pazartesi',
      'Tuesday': 'Salı',
      'Wednesday': 'Çarşamba',
      'Thursday': 'Perşembe',
      'Friday': 'Cuma',
      'Saturday': 'Cumartesi',
      'Sunday': 'Pazar'
    };

    if (this.person?.personalAdditionalInfarmation?.workingDays?.length) {
      return this.person.personalAdditionalInfarmation.workingDays
        .map(day => {
          const translatedDay = dayTranslations[day.day] || day.day;
          return `${translatedDay}: ${day.start} - ${day.end}`;
        })
        .join('\n'); // Her bir satır için \n
    }
    return 'Mesai saatleri yok'; // Mesai saatleri yoksa
  }


  days = [
    { name: 'Monday', label: 'Pazartesi', selected: false, startTime: { hour: 9, minute: 0 }, endTime: { hour: 18, minute: 0 } },
    { name: 'Tuesday', label: 'Salı', selected: false, startTime: { hour: 9, minute: 0 }, endTime: { hour: 18, minute: 0 } },
    { name: 'Wednesday', label: 'Çarşamba', selected: false, startTime: { hour: 9, minute: 0 }, endTime: { hour: 18, minute: 0 } },
    { name: 'Thursday', label: 'Perşembe', selected: false, startTime: { hour: 9, minute: 0 }, endTime: { hour: 18, minute: 0 } },
    { name: 'Friday', label: 'Cuma', selected: false, startTime: { hour: 9, minute: 0 }, endTime: { hour: 18, minute: 0 } },
    { name: 'Saturday', label: 'Cumartesi', selected: false, startTime: { hour: 10, minute: 0 }, endTime: { hour: 16, minute: 0 } },
    { name: 'Sunday', label: 'Pazar', selected: false, startTime: { hour: 10, minute: 0 }, endTime: { hour: 16, minute: 0 } },
  ];

  updateWorkingDays(workingDays: any[]): void {
    // Güncel çalışma günlerini "days" array'ine işliyoruz
    this.days.forEach(day => {
      const workingDay = workingDays?.find(wd => wd.day === day.name);
      if (workingDay) {
        day.selected = true;
        const [startHour, startMinute] = workingDay.start.split(':').map(Number);
        const [endHour, endMinute] = workingDay.end.split(':').map(Number);
        day.startTime = { hour: startHour, minute: startMinute };
        day.endTime = { hour: endHour, minute: endMinute };
      }
    });
  }

  splitWorkingDays(days: any[] | null | undefined, chunkSize: number): any[][] {
    if (!days || days.length === 0) {
      return [];
    }
    const result = [];
    for (let i = 0; i < days.length; i += chunkSize) {
      result.push(days.slice(i, i + chunkSize));
    }
    return result;
  }

  daysMap: { [key: string]: string } = {
    Monday: 'Pazartesi',
    Tuesday: 'Salı',
    Wednesday: 'Çarşamba',
    Thursday: 'Perşembe',
    Friday: 'Cuma',
    Saturday: 'Cumartesi',
    Sunday: 'Pazar'
  };

  // Günlerin Türkçe karşılığını döndürür
  getDayLabel(dayName: string): string {
    return this.daysMap[dayName] || dayName; // Eğer bir eşleşme yoksa orijinal ismi döndürür
  }
}